export default "__VITE_ASSET__CwKJVqEQ__"